import { render, staticRenderFns } from "./BioTestingTakeQuiz.vue?vue&type=template&id=4e4c9b61"
import script from "./BioTestingTakeQuiz.vue?vue&type=script&lang=js"
export * from "./BioTestingTakeQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports